import React from 'react';

import BackgroundImage from "../../images/sebraeNaDf.jpg";
import reuniaoImage from "../../images/reuniaoImagemDfAzul.jpg";
import reuniaoImageGreen from "../../images/reuniaoImagemDf.png";
import transitions from '@material-ui/core/styles/transitions';

import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({

  tituloAba: {
    fontSize: 25,
    fontWeight: 500,
    color: '#5e6784'
  },
  imgCard: {
    background: (` linear-gradient(to bottom, rgba(4, 48, 173, 0.7), 
		rgba(4, 48, 173, 0.7)),linear-gradient(to bottom, #000000, #000000),
		url(${BackgroundImage})  `),
    backgroundSize: 'cover',
    backgroundBlendMode: 'normal,color',
    width: 266,
    height: 148,
    borderRadius: 4,
    padding: 10
  },
  imgCardGreen: {
    background: (` linear-gradient(to bottom, rgba(1, 125, 121, 0.7), 
		rgba(1, 125, 121, 0.7)),linear-gradient(to bottom, #000000, #000000),
		url(${BackgroundImage})  `),
    backgroundSize: 'cover',
    backgroundBlendMode: 'normal,color',
    width: 266,
    height: 148,
    borderRadius: 4,
    padding: 10
  },
  card: {
    position: 'relative',
    boxSizing: 'border-box',
    width: 266,
    minHeight: 316,
    backgroundColor: "#fff",
    borderRadius: 4,
    transition: transitions.create(['box-shadow']),
    '&:hover': {
      boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
    }
  },
  cardInvite: {
    position: 'relative',
    boxSizing: 'border-box',
    border: 'solid 1px #dfdfe6',
    width: 206,
    minHeight: 236,
    backgroundColor: "#fff",
    borderRadius: 4,
    transition: transitions.create(['box-shadow']),
    '&:hover': {
      boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
    },
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  campoTextoImagemCard: {
    width: '100%',
    height: 85,
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10,
    padding: 0,
  },
  campoTextoCard: {
    fontSize: 20,
    fontWeight: 500,
    color: '#fff',
    fontFamily: 'IBM Plex Sans'
  },
  campoDataHoraCard: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#5e6784',
    fontFamily: 'IBM Plex Sans',
    alignItems: 'center',
    fontWeight: 500
  },
  campoEnderecoCard: {
    fontFamily: 'IBM PLex Sans',
    color: '#061243',
    fontSize: 16,
    margin: 0,
    padding: 0
  },
  campoMesAno: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5e6784',
    textTransform: 'uppercase'
  },
  //nova reunião
  reunioesAddButon: {
    position: 'absolute',
    top: 28,
    right: 7,
    width: 32,
    height: 21,
    borderTopRightRadius: 4,
    border: 'solid 1px #dfe1e6',
    color: '#6fceff',
    backgroundColor: '#f7f7fa',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    '&:active': {
      backgroundColor: '#e7e7ea'
    }
  },
  reunioesSubButon: {
    position: 'absolute',
    top: 48,
    right: 7,
    width: 32,
    height: 21,
    borderBottomRightRadius: 4,
    border: 'solid 1px #dfe1e6',
    color: '#6fceff',
    backgroundColor: '#f7f7fa',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    '&:active': {
      backgroundColor: '#e7e7ea'
    }
  },
  reunioesTituloCampoEditor: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,
    color: '#0430ad'
  },
  reunioesInputEditor: {
    marginBottom: 40,
    padding: '0 24px',
    marginTop: 150
  },
  campoOnDragAtivo: {
    border: 'dashed 2px #cdcdcd',
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
    alignItems: 'center',
    backgroundColor: '#A8CFFF',
  },
  campoOnDrag: {
    border: 'dashed 2px #cdcdcd',
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
    alignItems: 'center',
  },
  mainButon: {
    borderRadius: 6,
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    border: 'solid 1px #97c1ff',
    color: '#044ada',
    marginTop: 30,
    padding: '10px 20px',
    cursor: 'pointer',
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#edf4ff'
    },
  },
  gridLabelDocumentos: {
    fontSize: 16,
    fontWeight: 500,
    color: '#5e6784'
  },
  gridNomeArquivo: {
    fontSize: 16,
    lineHeight: 1.38,
    color: '#061243'
  },
  gridNomeArquivoDetalhe: {
    fontSize: 12,
    color: '#5e6784'
  },
  gridTamanho: {
    fontSize: 16,
    color: '#5e6784'
  },
  imagemReplaceFotoSmall: {
    width: 72,
    height: 72,
    backgroundColor: '#30b0ff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 24,
    fontWeight: 600,
    fontFamily: 'IBM Plex Sans',
    borderRadius: 44,
  },
  imagemReplaceFotoExtraSmallGray: {
    width: 64,
    height: 64,
    backgroundColor: '#dfdfe6',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 24,
    fontWeight: 600,
    fontFamily: 'IBM Plex Sans',
    borderRadius: 44,
  },
  imagemReplaceFotoExtraSmall: {
    width: 64,
    height: 64,
    backgroundColor: '#30b0ff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 24,
    fontWeight: 600,
    fontFamily: 'IBM Plex Sans',
    borderRadius: 44,
  },
  nomeCardInvite: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5e6784',
    padding: 0,
    margin: '12px 0 0 0 ',
  },
  informacoesCardInvite: {
    fontSize: 12,
    color: '#5e6784',
    padding: 0,
    margin: 0
  },
  informacoesCardInviteVerde: {
    fontSize: 12,
    color: '#008a00',
    padding: 0,
    margin: 0
  },
  informacoesCardInviteRed: {
    fontSize: 12,
    color: 'red',
    padding: 0,
    margin: 0
  },
  subTituloAba: {
    fontSize: 16,
    color: '#061243',
    fontWeight: 'bold',
    marginTop: 24
  },
  subTituloSpan: {
    fontSize: 12,
    color: '#5e6784',
    padding: 0,
    margin: 0
  },
  stepperBody: {
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0 2px 0 0 #dfdfe6'
  },
  //barra de filtro de reuniões
  barraFiltroDiv: {
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    padding: '0 24px'
  },
  barraFiltro: {
    width: '100%',
    backgroundColor: 'white',
    //minHeight: 106,
    boxShadow: '0 2px 0 0 #dfdfe6',
    padding: 20,

    zIndex: 1,
    marginTop: 100,
  },
  // editar a mesa
  mesaNomeUser: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5e6784'
  },
  mesaInfoUser: {
    fontSize: 12,
    color: '#5e6784'
  },
  mesaLinkUser: {
    fontSize: 14,
    fontWeight: 500,
    color: '#044ada',
    cursor: 'pointer',
    '&:disabled' : {
      color: '#808080'
    },
  },
  //visualizar reunião
  headerImage: {
    background: (`url(${reuniaoImage})`),
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    right: 0,
    width: '100%',
    minHeight: 292
  },
  headerImageVerde: {
    background: (`url(${reuniaoImageGreen})`),
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    right: 0,
    width: '100%',
    minHeight: 292
  },
  headerInfo: {
    fontWeight: 'bold',
    fontSize: 32,
    color: '#fff',
    textTransform: 'uppercase',
    margin: '5px 0',
    padding: '5px 0'
  },
  headerNome: {
    fontSize: 39,
    fontWeight: 500,
    color: '#fff',
    maxWidth: 750,
    width: '80%',
    margin: '5px 0',
    padding: '5px 0'
  },
  headerFooterButton: {
    backgroundColor: 'inherit',
    cursor: 'pointer',
    padding: '12px 24px',
    color: 'rgba(255,255,255,0.5)',
    '&:hover': {
      color: 'rgba(255,255,255,0.87)'
    }
  },
  headerFooterButtonActive: {
    backgroundColor: '#fafafa',
    padding: '12px 24px',
    color: '#044ada',
    fontFamily: 16,
    fontWeight: 500,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    cursor: 'pointer',
  },
  cardInfoAbaSobre: {
    backgroundColor: '#fff',
    border: '1px solid #dfdfe6',
    padding: 24,
    borderRadius: 4,
  },
  cardInfoAbaSobrePeriodicidade: {
    fontSize: 25,
    fontWeight: 500,
    color: '#5e6784',
  },
  cardInfoAbaSobreExtra: {
    color: '#02032a',
    fontSize: 16,
  },
  infoAbaSobreReuniao: {
    color: '#5e6784',
    fontSize: 16,
    lineHeight: 1.38
  },
  gridExibirMidia: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 24,
    marginTop: 12
  },
  optionsContainer: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    marginBottom: 21
  },
  midiaOptions: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 13,
    padding: '0 8px',
    lineHeight: '16px',
    color: '#617385',
    paddingBottom: 3,
    cursor: 'pointer',
    '&.active': {
      fontWeight: 800,
      borderBottom: '4px solid #617385',
    }
  },
  midiaTableHeader: {
    display: 'grid',
    gridTemplateColumns: '250px 1fr',
    padding: '0 19px 0 28px',
    gap: '8px',
    marginTop: 29,
    marginBottom: 6
  },
  midiaTableHeaderRows: {
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: '17px',
    color: '#848996',
  },
  midiaTableItens: {
    display: 'grid',
    padding: '26px 19px 26px 28px',
    gap: '8px',
    gridTemplateColumns: '250px 1fr 120px',
    background: '#FFFFFF',
    borderTop: '1px solid #E6E6E6',
    borderRight: '1px solid #E6E6E6',
    borderLeft: '1px solid #E6E6E6',
    boxSizing: 'border- box',
    '&:last-child': {
      borderBottom: '1px solid #e6e6e6',
    }
  },
  midiaTableIcons: {
    display: 'flex',
    gap: '26px',
    alignItems: 'center'
  },
  midiaSectionTitle: {
    fontSize: 21,
    fontWeight: 'bold',
    lineHeight: '25px',
    color: '#617385',
    marginTop: 17
  },
  midiaTableName: {
    fontFamily:'Lato',
    fontSize: 12,
    lineHeight: '14px',
    color: '#23263E',
  },
  midiaTableSize: {
    fontFamily:'Lato',
    fontSize: 11.5,
    lineHeight: '14px',
    color: '#90949F',
  },
  downloadMidia: {
    borderRadius: 6,
    fontFamily: 'IBM Plex Sans',
    boxShadow: 'none',
    textTransform: 'none',
    border: 'solid 1px #97c1ff',
    color: '#044ada',
    padding: '13px',
    cursor: 'pointer',
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#edf4ff'
    },
  },
  buttonDisabled: {
    color:  "rgba(0, 0, 0, 0.26)",
    border: "1px solid rgba(0, 0, 0, 0.12)"
  },
  menuItemDisabledSemFormulario: {
    color:  "rgba(0, 0, 0, 0.26)",
  },
  gridMaster: {
      marginTop: 150,
      padding: "0 24px",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      gap: 40,
  },
  gridSumula:{
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  gridFormularioInformacoes:{
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    flexWrap: "nowrap",
  },
  gridBotoesSumula:{ display: "flex", justifyContent: "flex-end", gap: 5, maxHeight: "55px" },
  gridSumulaDialogContent:{
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginBottom: "24px",
  },
  typographySumulaTitulos: {
    fontSize: "13px",
    fontStyle: "italic",
    fontWeight: "400",
    lineHeight: "normal",
  },
  typographySumulaTitulo: {
    fontSize: "13px",
    fontStyle: "italic",
    fontWeight: "400",
    lineHeight: "normal",
    textTransform: "uppercase",
  },
  gridSumulaMainContent:{
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    borderRadius: "8px",
    border: "1px solid #E0E5EB",
  },
  sumulaTypography:{
    fontSize: "19px",
    fontstyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  },
  sumulaSubTitulo:{
    textAlign: "center",
    fontSize: "39px",
    fontWeight: "700",
    padding: "80px 0",
  },
  gridSumulaDatas:{
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: "20px",
  }
}));

export default useStyle;
